import { render, staticRenderFns } from "./box5.vue?vue&type=template&id=4a1f73be&scoped=true&"
import script from "./box5.vue?vue&type=script&lang=js&"
export * from "./box5.vue?vue&type=script&lang=js&"
import style0 from "./box5.vue?vue&type=style&index=0&id=4a1f73be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1f73be",
  null
  
)

export default component.exports